<template>
    <div class="rhythmClass">
        <el-col :span="24" class="imgStyle" align="left">
            <div class="playTheDrumsLeft" v-if="!textVideoUrl"></div>
            <div class="haveGotOnTheBus" v-else>
                <video class="textAudioUrl" :src="textVideoUrl" controls></video>
            </div>
            <div class="playTheDrumsRight" :style="{width:textVideoUrl? '20%':'40%',marginLeft:textVideoUrl? '3%':''}">
                <div class="operBox" @click="submitNumLimit()">
                    <updata-video ref="upImg"
                        :class="['upShiping',textVideoUrl? 'youUpShiping':'']"
                        :style="{pointerEvents:(!(submitNum>0||submitNum==-1)? 'none':'auto')}"
                        :styleEd="'\
                            width: 100%;\
                            font-size: 17px;\
                            background-color: rgb(0, 204, 106);\
                            color: #fff;border-radius: 5px;\
                            border: 3px solid rgb(207, 255, 232);'"
                            @upImgUrl="upImgUrl($event)"
                        :text="yangText"
                        :limitSize="limitSize">
                    </updata-video>
                    <p class="operation-num">剩余上传次数：{{submitNum==-1? '不限次':submitNum}}</p>
                    <p class="operation-topTag" v-if="!textVideoUrl">请录制视频并上传，如上传较慢请您耐心等待</p>
                    <div class="operation-tag" v-if="!textVideoUrl">注：请上传mp4、WebM、Ogg格式的视频文件，文件大小限制在500MB内</div>
                </div>
            </div>
        </el-col>
    </div>
</template>
<script>
import updataVideo from '../../components/updataVideo'
import utils from '../../lib/util'
import wsMethod from '../../lib/socketMethod'
    export default {
        name:"textTopic",
        props: {
            sonData: Object,
            allAnswer:Object,
        },
        data() {
            return {
                heart:{
                    questionDto:{
                        detailInfo:{}
                    }
                },
                limitSize:'512000',//kb
                timeHer:'',
                advancedRadio:'',
                submitNum:0,
                questionImgUrl:'',
                textVideoUrl:'',
                yangText:'上传视频',
                score:'',//得分
                detailJsonVal:'',//得分细节 json
                answerType:null,
            }
        },
        components:{
            updataVideo
        },  
        watch: {
            'textVideoUrl':function(now,old){
                if(now&&this.answerType)this.answerType = null
                this.$emit('storeLocally')
            },
            'submitNum':function(now,old){
                this.$emit('storeLocally')
            },
            'answerType':function(now,old){
                this.$emit('storeLocally')
            }
        },
        computed:{},
        created(){},
        mounted(){
            this.heart = this.sonData
            this.submitNum = utils.mottoClone(this.heart.submitNum)
            this.$nextTick(function(){
                if(this.allAnswer){
                    this.textVideoUrl = this.allAnswer.obj.textVideoUrl
                    this.answerType = this.allAnswer.obj.answerType
                    this.submitNum = this.allAnswer.submitNum
                    if(this.textVideoUrl){
                        this.yangText = '重新上传'
                    }
                }
            })
        },
        methods:{
            upImgUrl(url){
                let plays = this.submitNum
                let nPlays = this.heart.submitNum
                if(plays>0||nPlays==-1){
                    this.textVideoUrl = url
                    this.$refs.upImg.url = ''
                    this.$refs.upImg.fileList = []
                    if(url){
                        this.yangText = '重新上传'
                    }
                    if(this.submitNum<=0) this.submitNum==-1? this.submitNum=-1:this.submitNum=0
                    else this.submitNum--;

                    this.$nextTick(()=>{
                        wsMethod.wsSend210(this.heart.bId,this.heart.questionId,{
                            allData:this.$parent.allData,
                            uuid1:this.$parent.uuid1,
                            firstStartDateVal:this.$parent.firstStartDateVal,
                        })
                    })
                }else{
                    this.$message({showClose: true,message: `只能上传${nPlays}次`})
                }
            },
            yesNotProblem(){
                this.questionImgUrl = this.textVideoUrl
                if(this.textVideoUrl) return true
                return false
            },
            submitNumLimit(){
                let plays = this.submitNum
                let nPlays = this.heart.submitNum
                if(plays>0||nPlays==-1){}else{
                    this.$message({showClose: true,message: `只能上传${nPlays}次`})
                }
            },
            changeAnswerType(val){
                this.answerType = val.answerType
            }
        }
    }
</script>
<style scoped lang="less">
    .rhythmClass{
        height: 100%;
        width: 100%;
        position: relative;
        .imgStyle{
            position: absolute;
            top: 0%;
            left: 0;
            bottom: 0;
            width: 100%;
            box-sizing: border-box;
            padding: 25px 18px;
            background-image: url('../../../static/images/back-bg.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
            .playTheDrumsLeft{
                width: 38%;
                height: 100%;
                float: left;
                position: relative;
                background-image: url('../../../static/images/takingPictures.png');
                background-size: 39%;
                background-position: 95% 50%;
                background-repeat: no-repeat;
            }
            .haveGotOnTheBus{
                width: 65%;
                height: 90%;
                margin: 30px;
                float: left;
                display: flex;
                vertical-align: middle;
                align-items: center;
                .textAudioUrl{
                    max-width: 100%;
                    max-height: 100%;
                    display: block !important;
                    margin: auto;
                }
            }
            .playTheDrumsRight{
                width: 40%;
                height: 100%;
                float: left;
                box-sizing: border-box;
                padding-left: 15px;
                position: relative;
                display: table;
                .operBox{
                    width: 100%;
                    display: table-cell;
                    vertical-align: middle;
                    text-align: center;
                    .upShiping{
                        width: 100%;
                    }
                    .operationGo{
                        width: 100%;
                        font-size: 17px;
                        background-color: rgb(0, 204, 106);
                        color: #fff;
                        border-radius: 5px;
                        border: 3px solid rgb(207, 255, 232);
                    }
                    .operation-num{
                        font-size: 13px;
                        text-align: center;
                    }
                    .operation-topTag{
                        width: 100%;
                        text-align: center;
                        font-size: 1rem;
                        margin-top: 5px;
                        color: #000;
                    }
                    .operation-tag{
                        // height: 20%;
                        width: 100%;
                        box-sizing: border-box;
                        padding: 9px 20px;
                        text-align: center;
                        background-color: #F4F9FE;
                        color: #1D8EFE;
                        font-size: 0.8rem;
                        margin-top: 7px;
                    }
                }
            }
        }
        @media only screen and (max-height: 713px) {
            .imgStyle{
                padding: 30px 18px;
            }
        }
    }
</style>
<style>
    .upShiping .el-upload{
        width: 100% !important;
    }
    .youUpShiping .el-upload-list--text{
        max-width:167px !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/exam/textTopic.vue